const API_URL = {
  LOGIN: `/v1/login`,
  LOGIN_DIRECT: `/v1/login-authenticate`,/* No OTP */
  LOGIN_THINKIFIC: `/v1/thinkific/login`,/* No OTP */
  THINKIFIC_CREATE_PASSWORD: `/v1/thinkific/create-password`,
  REGISTER: `/v1/register`,
  SEND_OTP: `/v1/sent-otp`,
  USER_REGISTER: (user_id: string): string => `/v1/user-register/${user_id}`,
  GET_USER: (user_id: string): string => `/v1/user-detail/${user_id}`,
  FORGOT_PASSWORD: `/v1/forgot-password`,
  ME: `/v1/me`,
  LOGOUT: `/v1/logout`,
  CHANGE_PASSWORD: `/v1/change-password`,
  UPDATE_PROFILE: `/v1/update-profile`,
  RESET_PASSWORD: (otp: string): string => `/v1/reset-password/${otp}`,
  VERIFY_PASSWORD: `/v1/verify-otp`,
  REFRESH_TOKEN: `/v1/refresh-token`,
  COMMON: {
    SYNC: `/v1/sync`,
    PRIVILEGES: `/v1/privileges-list`,
    ROLES_LIST: (search: string): string =>
      `/v1/roles-list${search ? `?search=${search}` : ""}`,
  },
  UPDATEPROFILE: `/v1/update-profile`,
  RACE: `/v1/race-list`,
  VETERAN: `/v1/veteran-statuses-list`,
  CMS_DETAIL: (slug: string): string => `/v1/cms/detail?slug=${slug}`,
  pageSettings: (type: string): string => `/v1/page-settings?type=${type}`,
  VR_TRAINING: `/v1/vr-training-location`,
  DELETE_ACCOUNT: `/v1/delete-account`,
  DISABLED_WELCOME_MODAL: `/v1/disabled-popup`,

  //exam section start
  EXAM_START: `/v1/assessment-exam/start`,
  INTEREST_ASSESSMENT: `/v1/interest-assessment`,
  SUBMIT_ANSWER: (id: any) => `/v1/assessment-exam/${id}/submit-answer`,
  TIER_ONE_SUBMIT_ANSWER: (id: any) =>
    `/v1/assessment-exam/${id}/tier-one-questions`,
  FINISH_EXAM: (id: any) => `/v1/assessment-exam/${id}/complete`,
  EXAM_LIST: `/v1/assessment-exam`,
  SKILL_ASSESSMENTU: `/v1/skill-assessment`,
  VIEW_ASSEMENT: (id: any) => `/v1/assessment-exam/${id}/details`,
  MASTER_LOV_DATA: (param: any) => `/v1${param}`,
  EXAM_RESULT: `/v1/assessment-exam/result`,
  EXAM_RESULT_PDF: `/v1/assessment-exam/download-result-pdf`,
  TRIAL_EXAM_RESULT_PDF: `/v1/trial-assessment-exam/download-result-pdf`,
  VERIFY_TOKEN: (token: string): string => `/v1/verify-email/${token}`,
  //exam section end
  // CAREER_LIST: (search: string): string => `/v1/careers-list${search ? "?search="+search : "" }`,
  CAREER_LIST: `/v1/careers-list`,
  CAREER_DETAILS: (career_id: number): string =>
    `/v1/career-detail/${career_id}`,
  MY_JOB_LIST: `/v1/job-list`,
  JOB_ADD_REMOVE: `/v1/saved-job/store`,
  CAREER_CATEGORY_LIST: `/v1/career-categories`,
  CAREER_CATEGORY_DETAILS: (cc_id: any) =>
    `/v1/career-category-detail/${cc_id}`,
  GET_ACCESS_CODE: (access_code_id: string): string =>
    `/v1/access-code-detail/${access_code_id}`,
  ACRONYM_LIST: `/v1/acronym-list`,
  ACRONYM_DETAILS: (acronym_id: any) => `/v1/acronym-details/${acronym_id}`,
  SetUserSpecialFlag: `/v1/update-flag`, //1 = exam flag , 2 = profile flag
  //exam section end
  INDUSTRY_LIST: "/v1/industry-list",
  CRITICAL_CAREER_LIST: "/v1/critical-career-list",
  UPDATE_USER_INDUSTRY: "/v1/update-industry",
  TRAINING_CERTIFICATE: "/v1/certifications",
  USER_RESET_EXAM: (user_id: any) => `/v1/reset-exam/${user_id}`,

  // Trial apis
  TRIAL_EXAM_START: "/v1/trial-exam-start",
  TRIAL_EXAM_GET: (exam_id: any) => `/v1/get-trial-exam/${exam_id}`,
  TRIAL_EXAM_FINISH: (exam_id: any) => `/v1/trial-exam/${exam_id}/complete`,
  TRIAL_EXAM_RESULT: "/v1/get-trial-result",
  TRIAL_USER_UPGRADE: "/v1/upgrade-user",
};

export default API_URL;
